<template>
  <div
      class="user-form text-start flex-grow-1 d-flex flex-column"
      data-aos="fade-left"
      data-aos-duration="1500"
  >
      <v-container class="p-0 d-flex flex-column flex-grow-1" fluid>
          <div class="page-card flex-grow-1">
              <h1 class="card-title mb-2">
                  <span v-if="!userId">Cadastrar</span>
                  <span v-else>Editar</span>
                  usuário
              </h1>
              <p class="card-subtitle mb-4 mb-md-5">
                  <span v-if="!userId">Preencha</span
                  ><span v-else>Edite</span> as informações básicas do
                  usuário.
              </p>
              <hr class="page-card__divider" />
              <div v-if="isLoading" class="pa-10">
                  <Loader />
              </div>
              <v-form
                  v-else
                  fast-fail
                  @submit.prevent="handleSubmit()"
                  ref="userForm"
              >
                  <v-row class="mt-2 mt-md-4">
                      <v-col
                          cols="12"
                          md="7"
                          offset-lg="2"
                          class="d-md-flex justify-content-md-center py-1"
                      >
                          <img
                              class="user-photo"
                              :class="{ 'gray-scale': !user.photo }"
                              :src="profileImage"
                          />

                          <div class="ms-md-4 flex-fill">
                              <v-label class="labeld" for="userPhotoInput"
                                  >Foto</v-label
                              >
                              <v-file-input
                                  id="userPhotoInput"
                                  v-model="user.photo"
                                  accept="image/*"
                                  class="inputd"
                                  variant="outlined"
                                  density="compact"
                                  :prepend-icon="false"
                                  prepend-inner-icon="mdi-camera"
                                  @change="onPhotoChange"
                                  @click:clear="clearPhoto"
                              ></v-file-input>
                          </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="5" class="py-1">
                          <v-label class="labeld required" for="userNameInput"
                              >Nome</v-label
                          >
                          <v-text-field
                              id="userNameInput"
                              v-model="user.name"
                              :rules="rules.name"
                              placeholder="João da Silva"
                              required
                              class="inputd"
                              variant="outlined"
                              density="compact"
                          ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="py-1">
                          <v-label
                              for="userEmailInput"
                              class="labeld required"
                          >
                              Email
                          </v-label>
                          <v-text-field
                              id="userEmailInput"
                              v-model="user.email"
                              :rules="rules.email"
                              placeholder="joao.silva@email.com"
                              required
                              type="email"
                              class="inputd"
                              variant="outlined"
                              density="compact"
                          ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" class="py-1">
                          <v-label
                              for="userTypeInput"
                              class="labeld required"
                          >
                              Tipo
                          </v-label>
                          <v-select
                              id="userTypeInput"
                              v-model="user.type"
                              :items="userTypes"
                              item-title="text"
                              item-value="value"
                              placeholder="Seleccione un tipo de usuario"
                              class="inputd"
                              variant="outlined"
                              density="compact"
                          />
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="py-1">
                          <v-label
                              class="labeld required"
                              for="userSocialNumber"
                              >CPF</v-label
                          >
                          <v-text-field
                              id="userSocialNumber"
                              placeholder="Digite o CPF"
                              v-model="user.socialNumber"
                              :rules="rules.socialNumber"
                              v-mask="'###.###.###-##'"
                              required
                              class="inputd"
                              variant="outlined"
                              density="compact"
                          />
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="py-1">
                          <v-label class="labeld" for="userIdNumber"
                              >Identidade</v-label
                          >
                          <v-text-field
                              id="userIdNumber"
                              placeholder="Digite o número da identidade"
                              v-model="user.idNumber"
                              class="inputd"
                              variant="outlined"
                              density="compact"
                          />
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="py-1">
                          <v-label class="labeld" for="userPhoneInput"
                              >Telefone</v-label
                          >
                          <v-text-field
                              id="userPhoneInput"
                              v-model="user.phone"
                              type="tel"
                              placeholder="(99) 99999-9999"
                              v-mask="'(##) #####-####'"
                              class="inputd"
                              variant="outlined"
                              density="compact"
                          />
                      </v-col>
                      <v-col cols="12" sm="4" md="2" class="py-1">
                          <v-label class="labeld" for="userPostCodeInput"
                              >CEP</v-label
                          >
                          <v-text-field
                              id="userPostCodeInput"
                              v-model="user.postcode"
                              placeholder="xxxxx-xxx"
                              v-mask="'#####-###'"
                              class="inputd"
                              variant="outlined"
                              density="compact"
                              @change="getCEP()"
                          />
                      </v-col>
                      <v-col cols="12" sm="8" md="5" class="py-1">
                          <v-label class="labeld" for="userAddressInput"
                              >Endereço</v-label
                          >
                          <v-text-field
                              v-model="user.address"
                              id="userAddressInput"
                              placeholder="Rua Exemplo"
                              class="inputd"
                              variant="outlined"
                              density="compact"
                              :loading="isLoadingAddress"
                          />
                      </v-col>
                      <v-col cols="12" sm="4" md="2" class="py-1">
                          <v-label class="labeld" for="userAddressNumberInput"
                              >Número</v-label
                          >
                          <v-text-field
                              id="userAddressNumberInput"
                              v-model="user.addressNumber"
                              placeholder="xxxx"
                              class="inputd"
                              variant="outlined"
                              density="compact"
                          />
                      </v-col>
                      <v-col cols="12" sm="8" md="3" class="py-1">
                          <v-label
                              class="labeld"
                              for="userAddressComplementInput"
                              >Complemento</v-label
                          >
                          <v-text-field
                              id="userAddressComplementInput"
                              v-model="user.addressComplement"
                              placeholder="Complemento"
                              class="inputd"
                              variant="outlined"
                              density="compact"
                              maxlength="100"
                          />
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="py-1">
                          <v-label class="labeld" for="userCityInput"
                              >Cidade</v-label
                          >
                          <v-text-field
                              id="userCityInput"
                              v-model="user.city"
                              placeholder="Cidade"
                              class="inputd"
                              variant="outlined"
                              density="compact"
                              maxlength="255"
                              :loading="isLoadingAddress"
                          />
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="py-1">
                          <v-label class="labeld" for="userStateInput"
                              >Estado</v-label
                          >
                          <v-select
                              id="userStateInput"
                              v-model="user.county"
                              :items="brazilianStates"
                              item-title="nome"
                              item-value="sigla"
                              placeholder="Selecione um estado"
                              class="inputd"
                              variant="outlined"
                              density="compact"
                              :loading="isLoadingAddress"
                          />
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="py-1">
                          <v-label class="labeld" for="userCountryInput"
                              >País</v-label
                          >
                          <v-select
                              id="userCountryInput"
                              v-model="user.country"
                              :items="[
                                  { nome: 'Brasil', sigla: 'br' },
                                  { nome: 'Outro', sigla: 'outro' },
                              ]"
                              item-title="nome"
                              item-value="sigla"
                              class="inputd"
                              variant="outlined"
                              density="compact"
                          />
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="py-1">
                          <v-label
                              for="userStatusSelect"
                              class="labeld required"
                          >
                              Status
                          </v-label>
                          <v-select
                              id="userStatusSelect"
                              v-model="user.status"
                              :items="statusTypes"
                              item-title="text"
                              item-value="value"
                              placeholder="Selecione o status"
                              class="inputd"
                              variant="outlined"
                              density="compact"
                          />
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="py-1">
                          <v-label
                              class="labeld required"
                              for="userPasswordInput"
                          >
                              Senha
                          </v-label>
                          <v-text-field
                              id="userPasswordInput"
                              v-model="user.password"
                              :append-inner-icon="
                                  showPassword ? 'mdi-eye' : 'mdi-eye-off'
                              "
                              :rules="rules.password"
                              :type="showPassword ? 'text' : 'password'"
                              :required="!userId"
                              class="inputd"
                              variant="outlined"
                              density="compact"
                              @click:append-inner="
                                  showPassword = !showPassword
                              "
                          />
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="py-1">
                          <v-label
                              class="labeld required"
                              for="userRePasswordInput"
                          >
                              Confirmar senha
                          </v-label>
                          <v-text-field
                              id="userRePasswordInput"
                              v-model="user.repassword"
                              :append-inner-icon="
                                  showPassword ? 'mdi-eye' : 'mdi-eye-off'
                              "
                              :rules="rules.repassword"
                              :type="showPassword ? 'text' : 'password'"
                              :required="!userId"
                              class="inputd"
                              variant="outlined"
                              density="compact"
                              @click:append-inner="
                                  showPassword = !showPassword
                              "
                          />
                      </v-col>
                      <v-col cols="12" class="mt-5 mt-md-6">
                          <v-row>
                              <v-col v-if="userId" cols="12" sm="4">
                                  <v-btn
                                      color="danger"
                                      height="47"
                                      variant="elevated"
                                      class="text-white"
                                      :disabled="isLoading"
                                      @click="openDeleteDialog"
                                      >Excluir</v-btn
                                  >
                              </v-col>
                              <v-col
                                  cols="12"
                                  :sm="userId ? 8 : 12"
                                  class="d-flex justify-content-center justify-content-md-end"
                              >
                                  <button
                                      class="btnd btnd--purple-transparent min-w-30 mr-4 mr-md-5"
                                      type="button"
                                      @click="$router.go(-1)"
                                  >
                                      Voltar
                                  </button>
                                  <v-btn
                                      class="btnd btnd--purple min-w-30"
                                      :height="47"
                                      type="submit"
                                  >
                                      Salvar
                                  </v-btn>
                              </v-col>
                          </v-row>
                      </v-col>
                  </v-row>
              </v-form>
          </div>
      </v-container>

      <v-dialog v-model="isDeleteDialogVisible" :max-width="600">
          <v-card class="modal-card">
              <v-card-title>
                  <h3 class="mb-0">
                      Você tem certeza que deseja excluir esse usuário?
                  </h3>
              </v-card-title>
              <v-card-subtitle>
                  Esta ação não poderá ser desfeita.
              </v-card-subtitle>
              <v-card-text>
                  <p class="mb-1">
                      Nome: <strong>{{ dataUserFetched?.name }}</strong>
                  </p>
                  <p class="mb-1">
                      Email: <strong>{{ dataUserFetched?.email }}</strong>
                  </p>
              </v-card-text>
              <v-card-actions>
                  <v-btn
                      class="flex-grow-1 cancel-btn"
                      color="grey-darken-4"
                      variant="tonal"
                      @click="isDeleteDialogVisible = false"
                      >Cancelar</v-btn
                  >
                  <v-btn
                      class="flex-grow-1 text-white"
                      color="danger"
                      variant="flat"
                      :loading="isLoading"
                      :disabled="isLoading"
                      @click="confirmDelete"
                      >Excluir</v-btn
                  >
              </v-card-actions>
          </v-card>
      </v-dialog>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  import {
      requiredRule,
      emailRule,
      minLengthRule,
      confirmPasswordRule,
  } from '@/utils/validations/index';
  import DefaultProfileImg from '@/assets/user.png';
  import apiCep from '@/utils/cep';
  import apiAWS from '@/utils/storage/aws';
  import apiUser from '@/utils/Weflix/user';
  import brazilianStates from '@/mocks/brazilianStates';


  import { toast } from 'vue3-toastify';
  import Loader from '@/components/Weflix/Loader';

  export default {
      components: {
          Loader,
      },
      name: 'UserForm',
      data() {
          return {
              isLoading: false,
              isLoadingAddress: false,
              user: {
                  name: '',
                  email: '',
                  photo: '', // pode ser string (url) ou File
                  type: 3,
                  socialNumber: '',
                  idNumber: '',
                  phone: '',
                  postcode: '',
                  address: '',
                  addressNumber: '',
                  addressComplement: '',
                  neighborhood: '',
                  city: '',
                  county: 'AC',
                  country: 'br',
                  status: 1,
                  password: '',
                  repassword: '',
              },
              dataUserFetched: null,
              previewPhotoUrl: '',
              photoHasChanged: false,
              rules: {
                  name: [requiredRule],
                  email: [requiredRule, emailRule],
                  socialNumber: [requiredRule],
                  password: [requiredRule, minLengthRule(4)],
                  repassword: [
                      requiredRule,
                      (value) =>
                          confirmPasswordRule(this.user.password)(value),
                  ],
              },
              userTypes: [
                  { text: 'Usuário', value: 3 },
                  { text: 'Gestor', value: 2 },
              ],
              statusTypes: [
                  { text: 'Ativo', value: 1 },
                  { text: 'Inativo', value: 0 },
              ],
              brazilianStates: brazilianStates,
              showPassword: false,
              isDeleteDialogVisible: false,
          };
      },
      computed: {
          ...mapState(['token']),
          userId() {
              return this.$route.params.slug || null;
          },
          profileImage() {
              // Se previewPhotoUrl estiver setada, retorna ela
              if (this.previewPhotoUrl) return this.previewPhotoUrl;
              // Se user.photo for string (url), retorna ela
              if (typeof this.user.photo === 'string' && this.user.photo)
                  return this.user.photo;
              // Caso contrário, retorna imagem padrão
              return DefaultProfileImg;
          },
      },
      beforeMount() {
          if (this.userId) {
              this.getUserData();
          }
      },
      mounted() {
          if (this.userId) {
              // Remove required rule from password fields when editing existing user
              this.rules.password = this.rules.password.filter(
                  (rule) => rule !== requiredRule
              );
              this.rules.repassword = this.rules.repassword.filter(
                  (rule) => rule !== requiredRule
              );
          }
      },
      methods: {
          onPhotoChange(event) {
              const file = event.target.files[0];
              this.updatePreview(file);
              this.photoHasChanged = true;
          },
          updatePreview(file) {
              // Limpa a url antiga se existir
              if (this.previewPhotoUrl) {
                  URL.revokeObjectURL(this.previewPhotoUrl);
                  this.previewPhotoUrl = '';
              }
              // Só cria url temporária se for File
              if (file instanceof File) {
                  this.previewPhotoUrl = URL.createObjectURL(file);
              } else {
                  this.previewPhotoUrl = '';
                  this.user.photo = '';
              }
          },
          clearPhoto() {
              this.previewPhotoUrl = '';
              this.user.photo = '';
          },
          openDeleteDialog() {
              if (this.dataUserFetched) {
                  this.isDeleteDialogVisible = true;
              }
          },
          async getUserData() {
              this.isLoading = true;
              this.isLoadingAddress = true;
              try {
                  const response = await apiUser.getUserId(
                      this.userId,
                      this.token
                  );
                  this.user = response;
                  this.dataUserFetched = response;
                  this.previewPhotoUrl = response.photoFinal;
              } catch (e) {
                  toast.error(
                      'Erro ao buscar os dados do usuário, por favor tente novamente.'
                  );
              } finally {
                  this.isLoading = false;
                  this.isLoadingAddress = false;
              }
          },
          async getCEP() {
              this.isLoadingAddress = true;
              try {
                  const response = await apiCep.getDataCep(
                      this.user.postcode
                  );
                  this.user.address = response.logradouro;
                  this.user.neighborhood = response.bairro;
                  this.user.city = response.localidade;
                  this.user.county = response.uf;
              } catch (error) {
                  toast.error(
                      'Erro ao buscar os dados do CEP, por favor verifique o CEP e tente novamente ou preencha os dados manualmente.'
                  );
              } finally {
                  this.isLoadingAddress = false;
              }
          },
          async putFileAws(url, file) {
              try {
                  const response = await apiAWS.putFileAWS(url, file);
                  return response;
              } catch (error) {
                  toast.error('Erro ao salvar a imagem.', 'error');
              }
          },
          async saveImageAws(file) {
              try {
                  const response = await apiAWS.getSignatureImage(
                      this.token,
                      file.name
                  );
                  await this.putFileAws(response.url, file);
                  return response.token;
              } catch (error) {
                  toast.error('Erro ao gerar token da imagem.', 'error');
              }
          },
          async handleSubmit() {
              this.isLoading = true;
              try {
                  if (
                      this.$refs.userForm.validate() &&
                      this.$refs.userForm.isValid
                  ) {
                      const payload = {
                          name: this.user.name,
                          email: this.user.email,
                          phone: this.user.phone.replace(/[^\d]/g, ''),
                          birthdate: '',
                          gender: '',
                          address: this.user.address,
                          addressComplement: this.user.addressComplement,
                          addressNumber: this.user.addressNumber,
                          neighborhood: this.user.neighborhood,
                          city: this.user.city,
                          county: this.user.county,
                          country: this.user.country,
                          postcode: this.user.postcode,
                          idNumber: this.user.idNumber,
                          socialNumber: this.user.socialNumber.replace(
                              /[^\d]/g,
                              ''
                          ),
                          status: this.user.status,
                          type: this.user.type,
                          photo: this.user.photo,
                      };

                      if (!this.userId) {
                          payload.password = this.user.password;
                          payload.repassword = this.user.repassword;
                      }

                      if (
                          this.photoHasChanged &&
                          this.user.photo instanceof File
                      ) {
                          payload.photo = await this.saveImageAws(
                              this.user.photo
                          );
                      }

                      let response;

                      if (this.userId) {
                          response = await apiUser.EditUser(
                              payload,
                              this.token,
                              this.userId
                          );
                      } else {
                          response = await apiUser.CreateUser(
                              this.token,
                              payload
                          );
                      }

                      this.$router.push({
                          params: { id: response?.data?.id },
                      });

                      toast.success(
                          'Usuário ' +
                              (this.userId ? 'editado' : 'criado') +
                              ' com sucesso!',
                          { persist: true }
                      );
                  } else {
                      toast.error(
                          'Por favor, corrija os erros no formulário antes de continuar.'
                      );
                  }
              } catch (error) {
                  const message = error.response?.data?.message
                      ? error.response.data.message
                      : 'Houve um erro enquanto tentava ' +
                        (this.userId ? 'editar' : 'criar') +
                        ' o usuário, por favor, tente novamente mais tarde.';

                  toast.error(message);
              } finally {
                  this.isLoading = false;
              }
          },
          async confirmDelete() {
              try {
                  this.isLoading = true;
                  await apiUser.EditUser(
                      {
                          ...this.dataUserFetched,
                          status: 9,
                          id: undefined,
                          photoFinal: undefined,
                          dateInsert: undefined,
                          orderStatus: undefined,
                      },
                      this.token,
                      this.dataUserFetched.id
                  );
                  toast.success('Usuário excluído com sucesso', {
                      persist: true,
                  });
                  this.$router.push({ path: '/dashboard/usuarios' });
                  
              } catch (error) {
                  toast.error('Erro ao excluir usuário:', error);
              } finally {
                  this.isDeleteDialogVisible = false;
                  this.isLoading = false;
                  this.dataUserFetched = { name: '', email: '' };
              }
          },
      },
  };
</script>

<style scoped>
  .user-photo {
      display: table;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      object-fit: cover;
      margin: auto;
  }

  .gray-scale {
      filter: grayscale(100%);
  }

  @media screen and (min-width: 768px) {
      .user-photo {
          margin: 0;
      }
  }
</style>
